
define('text!templates/modules/calendar/animated-session/custom-exercises-manager/edit/custom-exercise-edit-content.html',[],function () { return '<div class="panel-body exercise-edit-content">\n    <ul class="menu-actions nav nav-pills"></ul>\n    <div class="alert-list"></div>\n    <div class="exercise-edit-form"></div>\n</div>\n';});

